module.exports = __webpack_public_path__ + "img/what-is-ooca-bg.bec7a4df.png";